import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  assignStakingRiskProductToUserThunk,
  getAllStakingRiskProductsUserInfoThunk,
} from "../../Store/Thunks/ListingAssetsThunk";
import { Space, Table, Button } from "antd";
import Checkbox from "antd/lib/checkbox/Checkbox";
import { formatHtmlToText, limitText } from "./helpers";

const UserStakingRisk = ({ userId }) => {
  const dispatch = useDispatch();
  const userStakingRiskList = useSelector(
    (state) => state.ListingAssetsReducer.userStakingRiskList,
  );
  const assignStakingRiskUpdated = useSelector(
    (state) => state.ListingAssetsReducer.assignStakingRiskUpdated,
  );
  const [assetsState, setAssetsState] = useState([]);
  const [changes, setChanges] = useState([]);
  const [initialAssetsState, setInitialAssetsState] = useState([]);

  useEffect(() => {
    if (userId) {
      dispatch(getAllStakingRiskProductsUserInfoThunk(parseInt(userId)));
    }
  }, [userId, assignStakingRiskUpdated]);

  useEffect(() => {
    if (userStakingRiskList?.length) {
      const normalized = userStakingRiskList.map((item) => ({
        ...item.stakingRisk,
        userInfoId: item.id,
        show: item.show || false,
      }));

      setAssetsState(normalized);
      setInitialAssetsState(normalized); // important
    }
  }, [userStakingRiskList]);

  // const handleCheckboxChange = (id, checked) => {
  //   setAssetsState((prev) =>
  //     prev.map((item) =>
  //       item.id === id ? { ...item, selected: checked } : item,
  //     ),
  //   );

  //   dispatch(
  //     assignStakingRiskProductToUserThunk({
  //       userId: parseInt(userId),
  //       stakingRiskId: id,
  //       selected: checked,
  //     }),
  //   );
  // };

  const handleCheckboxChange = (id, checked) => {
    setAssetsState((prev) =>
      prev.map((item) =>
        item.userInfoId === id ? { ...item, show: checked } : item,
      ),
    );

    setChanges((prev) => {
      const exists = prev.find((c) => c.id === id);

      if (exists) {
        return prev.map((c) => (c.id === id ? { ...c, show: checked } : c));
      }

      return [...prev, { id, show: checked }];
    });
  };
  // const handleSave = () => {
  //   if (!changes.length) return;

  //   dispatch(
  //     assignStakingRiskProductToUserThunk({
  //       userId: parseInt(userId),
  //       stakingRiskUserInfos: changes,
  //     }),
  //   );

  //   setChanges([]);
  // };
  const handleSave = () => {
    if (!changes.length) return;

    dispatch(
      assignStakingRiskProductToUserThunk({
        userId: parseInt(userId),
        stakingRiskUserInfos: changes,
      }),
    );

    setChanges([]);
  };

  const handleSelectAll = (checked) => {
    const updated = assetsState.map((item) => ({
      ...item,
      show: checked,
    }));

    setAssetsState(updated);

    const updatedChanges = updated.map((item) => ({
      id: item.userInfoId,
      show: checked,
    }));

    setChanges(updatedChanges);
  };
  const allSelected =
    assetsState.length > 0 && assetsState.every((item) => item.show);
  const someSelected = assetsState.some((item) => item.show) && !allSelected;

  const columns = [
    {
      title: "#",
      key: "index",
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: "StakingRisk Name",
      dataIndex: "name",
      key: "",
      width: 250,
      ellipsis: true,
    },
    {
      title: "StakingRisk info",
      dataIndex: "info",
      key: "info",
      width: 250,
      ellipsis: true,
      render: (text) => (
        <div style={{ whiteSpace: "pre-line" }}>
          {limitText(formatHtmlToText(text), 300)}
        </div>
      ),
    },
    {
      title: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <span>Actions</span>
          <div>
            <Checkbox
              indeterminate={someSelected}
              checked={allSelected}
              onChange={(e) => handleSelectAll(e.target.checked)}
            />
            <span style={{ marginLeft: 10 }}>Select/Unselect</span>
          </div>
        </div>
      ),
      width: 150,
      render: (_, record) => (
        <Space size="small">
          <Checkbox
            className="custom-checkbox"
            checked={record.show || false}
            onChange={(e) => {
              handleCheckboxChange(record.userInfoId, e.target.checked);
            }}
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <Space style={{ margin: '0 auto 16px', display: 'flex', justifyContent: 'center' }}>
        <Button type="primary" onClick={handleSave}>
          Assign Changes
        </Button>
      </Space>

      <Table
        rowKey="userInfoId"
        columns={columns}
        dataSource={assetsState}
        pagination={false}
        scroll={{ y: 500 }}
      />
    </>
  );
};

export default UserStakingRisk;
